import { makeAutoObservable } from 'mobx';

interface CountryArgs {
	id: number;
	name: string;
}

export class Country {
	private _id: number;
	private _name: string;

	constructor(args: CountryArgs) {
		makeAutoObservable(this);

		this._id = args.id;
		this._name = args.name;
	}

	// getters

	get id() {
		return this._id;
	}
	get name() {
		return this._name;
	}

	// getters end
}
